import { Modal } from '@boss/ui';

import OrderImport from './OrderImport';

interface OrderImportModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const OrderImportModal = ({ isOpen, onClose }: OrderImportModalProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Modal className="md:max-w-[900px]" data-testid="order-import-modal" onClose={onClose}>
      <OrderImport mode="modal" onClose={onClose} />
    </Modal>
  );
};

export default OrderImportModal;
